import {DiscountTypes} from "./diacountConstants";

export function discountListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      adminPlansId: resource.plansId.map((item) => ({plansId : item})),
      adminSpecialistIds: resource.specialistIds.map((item) => ({specialistIds : item})),
      adminClinicCategories: resource.clinicCategories.map((item) => ({clinicCategories : item})),
      adminSpecialistCardIds: resource.specialistCardIds.map((item) => ({specialistCardIds : item})),
      typeName: getType(resource.type)
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateDiscountId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixCreateDiscountId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function discountMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId,
      adminPlansId: json.result.plansId.map((item) => ({plansId : item})),
      adminSpecialistIds: json.result.specialistIds.map((item) => ({specialistIds : item})),
      adminClinicCategories: json.result.clinicCategories.map((item) => ({clinicCategories : item})),
      adminSpecialistCardIds: json.result.specialistCardIds.map((item) => ({specialistCardIds : item})),
      typeName: getType(json.result.type)
    },
  };
}

export function getType(type) {
  DiscountTypes.forEach((item) => {
    if (item.id === type) {
      return item.name;
    }
  });

  return '';
}
